import React, { useState, useEffect } from "react"
import { listAllUsers } from "../../../utils/platformPeopleHelpers"
import LearnerDetail from "./LearnerDetail"

const PeoplePanel = ({ initialUid, onConsumeInitialUid }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedUid, setSelectedUid] = useState(initialUid || null)

  useEffect(() => {
    const load = async () => {
      const { users: allUsers } = await listAllUsers()
      setUsers(allUsers || [])
      setLoading(false)
    }
    load()
  }, [])

  useEffect(() => {
    if (initialUid) {
      setSelectedUid(initialUid)
      onConsumeInitialUid?.()
    }
  }, [initialUid])

  if (selectedUid) {
    return <LearnerDetail uid={selectedUid} onBack={() => setSelectedUid(null)} />
  }

  if (loading) {
    return <div className="p-6 text-center text-muted-foreground text-sm">Loading people...</div>
  }

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h2 className="font-semibold text-foreground">All People</h2>
        <span className="text-sm text-muted-foreground">{users?.length || 0} total</span>
      </div>

      {users?.length === 0 ? (
        <div className="p-6 text-center text-muted-foreground text-sm">No users yet.</div>
      ) : (
        <div className="divide-y divide-border">
          {users?.map((user) => (
            <button
              key={user?.uid}
              onClick={() => setSelectedUid(user?.uid)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left"
            >
              {user?.avatarUrl ? (
                <img src={user.avatarUrl} alt={user?.name} className="size-8 rounded-full object-cover shrink-0" />
              ) : (
                <div className="size-8 rounded-full bg-muted shrink-0" />
              )}
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{user?.name || "Unnamed"}</p>
                <p className="text-xs text-muted-foreground truncate">{user?.email || "—"}</p>
              </div>
              <span className="text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground shrink-0">
                {user?.accountType === "organization" ? "Org Admin" : "Learner"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default PeoplePanel